export default __webpack_public_path__ + "static/media/soal no 2 benar _ salah.08e7392d.png";